<template>
  <aside class="sidebar">
    <nav class="sidebar-nav">
      <router-link 
        to="/one-stop-service" 
        class="nav-item" 
        :class="{ 'sidebar-header': activeItem === 'one-stop-service' }"
      >
        咨询服务
      </router-link>
      <router-link 
        to="/foreign-trade-agent" 
        class="nav-item" 
        :class="{ 'sidebar-header': activeItem === 'foreign-trade-agent' }"
      >
        外贸代理
      </router-link>
      <router-link 
        to="/exclusive-service" 
        class="nav-item" 
        :class="{ 'sidebar-header': activeItem === 'exclusive-service' }"
      >
        专属服务
      </router-link>
      <router-link 
        to="/trademark-registration" 
        class="nav-item" 
        :class="{ 'sidebar-header': activeItem === 'trademark-registration' }"
      >
        商标注册
      </router-link>
      <router-link 
        to="/order-financing" 
        class="nav-item" 
        :class="{ 'sidebar-header': activeItem === 'order-financing' }"
      >
        订单融资
      </router-link>
      <router-link 
        to="/credit-insurance" 
        class="nav-item" 
        :class="{ 'sidebar-header': activeItem === 'credit-insurance' }"
      >
        信用保险
      </router-link>
      <router-link 
        to="/credit-investigation" 
        class="nav-item" 
        :class="{ 'sidebar-header': activeItem === 'credit-investigation' }"
      >
        资信调查
      </router-link>
      <router-link 
        to="/international-storage" 
        class="nav-item" 
        :class="{ 'sidebar-header': activeItem === 'international-storage' }"
      >
        国际储运
      </router-link>
      <router-link 
        to="/ship-booking" 
        class="nav-item" 
        :class="{ 'sidebar-header': activeItem === 'ship-booking' }"
      >
        租船订舱
      </router-link>
      <router-link 
        to="/document-service" 
        class="nav-item" 
        :class="{ 'sidebar-header': activeItem === 'document-service' }"
      >
        单证服务
      </router-link>
      <router-link 
        to="/transport-insurance" 
        class="nav-item" 
        :class="{ 'sidebar-header': activeItem === 'transport-insurance' }"
      >
        运输保险
      </router-link>
      <router-link 
        to="/cross-border-ecommerce" 
        class="nav-item" 
        :class="{ 'sidebar-header': activeItem === 'cross-border-ecommerce' }"
      >
        跨境电商
      </router-link>
      <router-link 
        to="/foreign-exchange" 
        class="nav-item" 
        :class="{ 'sidebar-header': activeItem === 'foreign-exchange' }"
      >
        结汇售汇
      </router-link>
      <router-link 
        to="/russian-trade" 
        class="nav-item" 
        :class="{ 'sidebar-header': activeItem === 'russian-trade' }"
      >
        对俄贸易
      </router-link>
      <router-link 
        to="/tax-refund" 
        class="nav-item" 
        :class="{ 'sidebar-header': activeItem === 'tax-refund' }"
      >
        退税申请
      </router-link>
      <router-link 
        to="/intellectual-property" 
        class="nav-item" 
        :class="{ 'sidebar-header': activeItem === 'intellectual-property' }"
      >
        知识产权
      </router-link>
      <router-link 
        to="/legal-consultant" 
        class="nav-item" 
        :class="{ 'sidebar-header': activeItem === 'legal-consultant' }"
      >
        法律顾问
      </router-link>
    </nav>
  </aside>
</template>

<script>
export default {
  name: 'SidebarNav',
  props: {
    activeItem: {
      type: String,
      default: 'one-stop-service'
    }
  }
}
</script>

<style scoped>
/* 左侧边栏 */
.sidebar {
  width: 240px;
  background: white;
  border-radius: 0;
  box-shadow: none;
  border: 1px solid #e0e0e0;
  height: fit-content;
}

.sidebar-header {
  background: #4A90E2;
  color: white;
  padding: 15px 20px;
  margin: 0;
  font-size: 16px;
  font-weight: bold;
  border-bottom: 1px solid #e0e0e0;
}

.sidebar-nav {
  display: flex;
  flex-direction: column;
}

.nav-item {
  display: block;
  padding: 12px 20px;
  color: #333;
  text-decoration: none;
  border-bottom: 1px solid #f0f0f0;
  transition: all 0.3s ease;
  font-size: 14px;
}

.nav-item:hover {
  background: #f8f9fa;
  color: #4A90E2;
}

.nav-item:last-child {
  border-bottom: none;
}

.nav-item.router-link-active {
  background: #e3f2fd;
  color: #4A90E2;
  font-weight: 500;
}
</style>